<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'REFERRALS'" [breadcrumb]="breadcrumb" [count]="count"
    icon="fa-tasks">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="taskGridAdvancedSwitch" [storageKey]="'referral-tasks-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-REFERRAL' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-REFERRAL' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3" (resized)="onResized($event)">
        <kendo-grid #grid id="referral-task-list" [data]="loadAllReferrals ? view.gridData : gridView"
            [pageable]="count > (loadAllReferrals ? view.state.take : state.take) ? { buttonCount: 5, pageSizes: pageSizes} : false"
            [pageSize]="loadAllReferrals ? view.state.take : state.take"
            [skip]="loadAllReferrals ? view.state.skip : state.skip"
            [loading]="loadAllReferrals ? view.loading : loading"
            [sort]="loadAllReferrals ? view.state.sort : state.sort"
            [filter]="loadAllReferrals ? view.state.filter : state.filter" [sortable]="true"
            [groupable]="loadAllReferrals" [group]="loadAllReferrals ? view.groups : []" [reorderable]="enableAdvanced"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
            (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)"
            [kendoGridExpandDetailsBy]="expandDetailsBy" [(expandedDetailKeys)]="expandedDetailKeys">
            <kendo-grid-messages noRecords="{{ 'NO-REFERRALS' | translate }}">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                <button kendoButton (click)="refresh()" class="float-right">
                    {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
                </button>
                <button kendoButton (click)="filterDialogOpened=true">{{ 'SAVE-FILTER' | translate }}</button>
            </ng-template>
            <kendo-grid-column field="name" title="{{'TASK-NAME' | translate}}" [width]="60"
                [hidden]="shouldHide('name')" [groupable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="ellipsis-text">{{dataItem.name}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="eligibilityAPIEnabled" [width]="20">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a *ngIf="dataItem.memberId" title="{{'VERIFY-MEDICAID-ELIGIBILITY' | translate}}"
                        (click)="checkMedicaidEligibility(dataItem.memberId)">
                        <i class="fas fa-clipboard-check fa-lg pl-2 pointer" style="color: #7f9852"
                            attr.aria-label="{{'VERIFY-MEDICAID-ELIGIBILITY' | translate}}">
                        </i>
                    </a>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eventReferral.referredServiceName" title="{{ 'SERVICE-NAME' | translate }}"
                [width]="60" class="emphasizedLabel pointer font-weight-bold"
                [hidden]="shouldHide('eventReferral.referredServiceName')" [groupable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.eventReferral" title="{{dataItem.eventReferral.referredServiceName}}"
                        (click)="openCommunityServiceInfo(dataItem.memberId, dataItem.eventReferral.referredProgramId)"
                        class="ellipsis-text-4">{{dataItem.eventReferral.referredServiceName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eventReferral.serviceType" title="{{ 'COMMUNITY-SERVICE-TYPE' | translate }}"
                [width]="40" class="pointer" [hidden]="shouldHide('eventReferral.serviceType')" [groupable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.eventReferral" title="{{dataItem.eventReferral.serviceType}}"
                        class="ellipsis-text-4">{{dataItem.eventReferral.serviceType}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eventReferral.serviceCategory"
                title="{{ 'COMMUNITY-SERVICE-CATEGORY' | translate }}" [width]="40" class="pointer"
                [hidden]="shouldHide('eventReferral.serviceCategory')" [groupable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.eventReferral" title="{{dataItem.eventReferral.serviceCategory}}"
                        class="ellipsis-text-4">{{dataItem.eventReferral.serviceCategory}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="caseId" title="{{'CASE-ID-NUMBER' | translate}}" [width]="40" filter="numeric"
                format="{0:n}" [hidden]="shouldHide('caseId')" [groupable]="true">
            </kendo-grid-column>
            <kendo-grid-column field="caseName" title="{{ 'MEMBER' | translate:patientLabel }}" [width]="60"
                class="pointer" [hidden]="shouldHide('caseName')">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.caseName}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="memberInfo.dateOfBirth" title="{{ 'DATE-OF-BIRTH' | translate }}" [width]="60"
                [filterable]="true" [sortable]="true" [groupable]="false">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq">
                        <kendo-filter-eq-operator></kendo-filter-eq-operator>
                        <kendo-filter-neq-operator></kendo-filter-neq-operator>
                        <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                        <kendo-filter-after-operator></kendo-filter-after-operator>
                        <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                        <kendo-filter-before-operator></kendo-filter-before-operator>
                    </kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.memberInfo !== null && dataItem.memberInfo.dateOfBirth !== null && 
                                dataItem.memberInfo.dateOfBirth !== undefined && !loading">
                        {{ intl.formatDate(intl.parseDate(dataItem.memberInfo.dateOfBirth), "d") }}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="address" title="{{ 'ADDRESS' | translate }}" [width]="70" [filterable]="false"
                [sortable]="false" [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.address">
                        <span
                            *ngIf="dataItem.address.streetLine || dataItem.address.streetLineAdditional">{{dataItem.address.streetLine}}
                            {{dataItem.address.streetLineAdditional}}<br />
                        </span>
                        <span *ngIf="dataItem.address.city">{{dataItem.address.city}}</span>
                        <span *ngIf="dataItem.address.state">
                            <span *ngIf="dataItem.address.city">,&nbsp;</span>{{dataItem.address.state.code}}
                        </span>
                        <span *ngIf="dataItem.address.postalCode">
                            {{dataItem.address.postalCode}}
                        </span>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="phone" title="{{'PHONE' | translate}}" [width]="90" [sortable]="false"
                [filterable]="false" [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div
                        *ngIf="dataItem.memberInfo !== null && dataItem.memberInfo.homePhoneNumber !== null && dataItem.memberInfo.homePhoneNumber !== ''">
                        <i class="fas fa-phone fa-fw" title="{{'HOME-OR-PRACTICE-PHONE' | translate}}"></i>
                        {{dataItem.memberInfo.homePhoneNumber | phone}}
                    </div>
                    <div
                        *ngIf="dataItem.memberInfo !== null && dataItem.memberInfo.cellPhoneNumber !== null && dataItem.memberInfo.cellPhoneNumber !== ''">
                        <i class="fas fa-mobile-alt fa-fw" title="{{'CELL' | translate}}"></i>
                        {{dataItem.memberInfo.cellPhoneNumber | phone}}
                    </div>
                    <div
                        *ngIf="dataItem.memberInfo !== null && dataItem.memberInfo.workPhoneNumber !== null && dataItem.memberInfo.workPhoneNumber !== ''">
                        <i class="fas fa-phone-office fa-fw" title="{{'WORK-PHONE' | translate}}"></i>
                        {{dataItem.memberInfo.workPhoneNumber | phone}}<span
                            *ngIf="dataItem.memberInfo.workPhoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                            translate}}&nbsp;{{dataItem.memberInfo.workPhoneNumberExtension}}</span>
                    </div>
                    <div
                        *ngIf="dataItem.memberInfo !== null && dataItem.memberInfo.otherPhoneNumber !== null && dataItem.memberInfo.otherPhoneNumber !== ''">
                        <i class="fas fa-phone fa-fw" title="{{'OTHER-PHONE' | translate}}"></i>
                        {{dataItem.memberInfo.otherPhoneNumber | phone}}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="memberInfo.email" title="{{'EMAIL' | translate}}" [width]="90"
                [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.memberInfo !== null && dataItem.memberInfo.email !== ''" class="ellipsis-text">
                        {{dataItem.memberInfo.email}}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="assigneeName" title="{{'ASSIGNED-TO' | translate}}" [width]="70"
                [groupable]="false" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.assigneeName}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="95" filter="date"
                format="{0:d}" [groupable]="false">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                        <kendo-filter-eq-operator></kendo-filter-eq-operator>
                        <kendo-filter-neq-operator></kendo-filter-neq-operator>
                        <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                        <kendo-filter-after-operator></kendo-filter-after-operator>
                        <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                        <kendo-filter-before-operator></kendo-filter-before-operator>
                    </kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{intl.formatDate(intl.parseDate(dataItem.openedOn), "g")}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="dueDate" title="{{ 'DUE-DATE' | translate }}" [width]="80" filter="date"
                format="{0:d}" [hidden]="shouldHide('dueDate')" [groupable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                        <kendo-filter-eq-operator></kendo-filter-eq-operator>
                        <kendo-filter-neq-operator></kendo-filter-neq-operator>
                        <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                        <kendo-filter-after-operator></kendo-filter-after-operator>
                        <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                        <kendo-filter-before-operator></kendo-filter-before-operator>
                        <kendo-filter-isnull-operator></kendo-filter-isnull-operator>
                        <kendo-filter-isnotnull-operator></kendo-filter-isnotnull-operator>
                    </kendo-grid-date-filter-cell>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{intl.formatDate(intl.parseDate(dataItem.dueDate), "d")}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="priority" title="{{ 'PRIORITY' | translate }}" [width]="49" class="text-center"
                [columnMenu]="false" [hidden]="shouldHide('priority')" [groupable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="distinctPriorities" filterField="priority"
                        selectDefaultText="{{ 'SELECT-PRIORITY' | translate }}" textField="priorityName"
                        valueField="priority">
                    </app-dropdown-filter>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div [className]="dataItem.priorityBadgeClass">
                        {{ dataItem.priority.charAt(0) }}</div>
                </ng-template>
            </kendo-grid-column>
            <ng-template kendoGridDetailTemplate let-dataItem>
                <!-- task detail -->
                <app-task-detail [showDetails]="showDetails" [task]="dataItem" (completed)="onTaskCompleted()"
                    [isDialog]="false" [gridContainerWidth]="gridContainerWidth">
                </app-task-detail>
            </ng-template>
        </kendo-grid>
    </div>
</div>

<!-- save filter dialog -->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="'Referral-Task'" [filterState]="state"
    (cancelling)="filterDialogOpened=false;" [filter]="filterSelected">
</app-save-filter>

<app-community-service-info *ngIf="programOpened" [memberId]="memberId" [programIds]="[programId]"
    (cancelling)="closeCommunityServiceInfo()">
</app-community-service-info>

<!--Medicaid Eligibility-->
<app-patient-eligibility #patientEligibility></app-patient-eligibility>